import { safeWindow } from '../safeWindow';

export function getCurrentPath(): string {
  const pathPostfix = safeWindow()?.location?.pathname.split('/')
    .pop();

  return pathPostfix ? `/${pathPostfix}` : '/';
}

export function isPathSameAsRoute(
  path: string,
  routePath = getCurrentPath(),
): boolean {
  return `${routePath}` === path;
}

export function isRouteHasPath(
  path: string,
  route: Record<string, string>,
): boolean {
  return !!Object.values(route)
    .find((routePath) => path === routePath);
}

export function getRouteWithSearchQuery(route: string): string {
  return `${route}${safeWindow().location?.search ?? ''}`;
}
